export default class Collection<T = any> {
  protected _items: Set<T> = new Set<T>();
  private _refreshArray: boolean = true;
  all: T[] = [];

  find(callback: (item: T) => boolean): T {
    return Array.from(this._items).find(item => callback(item));
  }

  filter(callback: (item: T) => boolean): T[] {
    return Array.from(this._items).filter(item => callback(item))
  }

  has(value: T): boolean {
    return this._items.has(value);
  }

  toggle(value: T): void {
    this.refresh(() => {
      if (this.has(value)) {
        this.remove(value);
      } else {
        this.add(value);
      }
    });
  }

  add(item: T): void {
    this.refresh(() => {
      this._items.add(item);
    });
  }

  addMany(items: T | T[]): void {
    this.refresh(() => {
      if (items instanceof Array) {
        items.forEach(item => {
          this.add(item);
        });
      } else {
        this.add(items);
      }
    });
  }

  remove(item: T): void {
    this.refresh(() => {
      this._items.delete(item);
    });
  }

  removeAll(): void {
    this.refresh(() => {
      this._items.forEach(item => {
        this.remove(item);
      });
    });
  }

  set(items: T | T[]): void {
    this.refresh(() => {
      this.removeAll();
      this.addMany(items);
    });
  }

  get length(): number {
    return this.all.length;
  }

  get first(): T {
    return this.all[0];
  }

  get isEmpty(): boolean {
    return this.length <= 0;
  }

  forEach(f: (item: T, itemAgain: T, set: Set<T>) => void): void {
    this._items.forEach((setItem, setItemAgain, theSet) => f(setItem, setItemAgain, theSet))
  }

  map<R = any>(f: (item: T, itemAgain: T, set: Set<T>) => R) {
    const results: R[] = []
    this.forEach((setItem, setItemAgain, theSet) => {
      results.push(f(setItem, setItemAgain, theSet))
    })
    return results
  }

  refreshArray(): void {
    this.all = Array.from(this._items);
  }

  refresh(f: () => void = null) {
    if (f) {
      const wasRefreshArray = this._refreshArray;
      this._refreshArray = false;
      f();
      this._refreshArray = wasRefreshArray;
    }
    if (this._refreshArray) {
      this.refreshArray();
    }
  }
}
